import {RestApiService} from '../../../rest-api.service';
import {
    BaseTaskRes,
    ProjectCreateReq,
    ProjectMinRes,
    ProjectSummaryAggregationRes,
    ProjectSummaryGroupingRes,
    ProjectTrackerRes,
    ProjectUpdateReq
} from '../../../../contracts/v0/crm';
import {ApiV0Crm} from '../api.v0.crm';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {UserDetailsRes} from '../../../../contracts/v0/cp';
import {InvoiceDetailRes} from '../../../../contracts/v0/cp/invoice.contract';

export class ApiV0CrmProject {
    segment = '/project';

    constructor(v0: ApiV0Crm, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }

    details(id: number) {
        return this.rest.get<ProjectTrackerRes>(`${this.segment}/${id}`, ProjectTrackerRes)
    }

    search(searchModel?: SearchModel) {
        return this.rest.post<SearchModel, BaseCollectionModel<ProjectMinRes, ProjectSummaryAggregationRes, ProjectSummaryGroupingRes>>
        (`${this.segment}/search`, ProjectTrackerRes, searchModel)
    }

    delete(projectId: number) {
        return this.rest.delete<void>(`${this.segment}/${projectId}`);
    }

    bulkDelete(ids: number[]) {
        console.log(ids)
        return this.rest.delete<void>(this.segment, {}, ids)
    }

    create(createReq: ProjectCreateReq) {
        return this.rest.post<ProjectCreateReq, ProjectMinRes>(`${this.segment}`, ProjectTrackerRes, createReq)
    }

    patchProject(id: number, updateReq: ProjectUpdateReq) {
        return this.rest.patch<ProjectUpdateReq, ProjectMinRes>(`${this.segment}/${id}`, ProjectTrackerRes, updateReq)
    }

    getDistinctNames() {
        return this.rest.get<BaseCollectionModel<string>>(`${this.segment}/names`)
    }

    tasks(id: number) {
        return this.rest.get<BaseCollectionModel<BaseTaskRes>>(`${this.segment}/${id}/tasks`, BaseTaskRes)
    }

    team(id: number) {
        return this.rest.get<BaseCollectionModel<UserDetailsRes>>(`${this.segment}/${id}/team`, UserDetailsRes)
    }

    invoices(id: number) {
        return this.rest.get<BaseCollectionModel<InvoiceDetailRes>>(`${this.segment}/${id}/invoices`, InvoiceDetailRes)
    }
}
